import type { Language } from "@app/constants";
import type { AccountType } from "@app/entities";

interface Message {
	bankName: string;
	branchCode: string;
	accountNumber: string;
	accountType: {
		[key in AccountType]: string;
	} & { header: string };
	accountDeletionHeader: string;
	deleteAccountButton: string;
}

type MessageData = {
	[key in Language]: Message;
};

const messages: MessageData = {
	en: {
		accountDeletionHeader: "Confirm account deletion",
		bankName: "Bank: ",
		branchCode: "Branch Code: ",
		accountType: {
			header: "Account Type: ",
			bond: "Bond Account",
			cheque: "Current/Cheque Account",
			credit: "Credit Card Account",
			savings: "Savings Account",
			subscription: "Subscription Account",
			transmission: "Transmission Account",
		},
		accountNumber: "Account Number: ",
		deleteAccountButton: "Delete account",
	},
};

export default messages;
